export const STEP_FRAMES = 6;
export const ROTATE_FRAMES = 4;
export const HOP_HEIGHT = 0.3;
export const FALL_FRAMES = 8;
export const JITTER_FRAMES = 6;
export const PLACE_JUMP_FRAMES = 4;
export const BOX_FALL_FRAMES = 8;
export const CEILING_CLEARANCE = 1.5;
